Unit App.ReturnTypes;

Interface

Uses
  System.SysUtils,
  Generics.Collections,
  App.Enumerations {$IFDEF PAS2JS},
  JS{$ENDIF};

Type

  TBasicResponseStatus = (rsOK, rsError);

  TBasicResponse = class
  private
    function GetStatus: TBasicResponseStatus;
    procedure SetStatus(const Value: TBasicResponseStatus);
  public
    StatusStr: String;
    Entity: String;
    Action: String;
    Description: String;
    property Status: TBasicResponseStatus read GetStatus write SetStatus;
{$IFDEF PAS2JS}
    Constructor Create(Value: TJSObject);
{$ENDIF}
  end;

  TIdAndName = Class
    Id: Integer;
    Name: String;
{$IFDEF PAS2JS}
    Procedure Assign(Value: TJSObject);
    Constructor Create(Value: TJSObject);
{$ENDIF}
  End;

Implementation

Uses
  System.StrUtils,
  Rtti,
  System.DateUtils;

{$IFDEF PAS2JS}

Constructor TBasicResponse.Create(Value: TJSObject);
begin
  StatusStr := String(Value['StatusStr']);
  Entity := String(Value['Entity']);
  Description := String(Value['Description']);
end;

Procedure TIdAndName.Assign(Value: TJSObject);
Begin
  Id := Integer(Value['Id']);
  Name := String(Value['Name']);
End;

Constructor TIdAndName.Create(Value: TJSObject);
Begin
  Assign(Value);
End;


{$ENDIF}

{ TBasicResponse }

function TBasicResponse.GetStatus: TBasicResponseStatus;
begin
  Result := TRttiEnumerationType.GetValue<TBasicResponseStatus>(StatusStr);
end;

procedure TBasicResponse.SetStatus(const Value: TBasicResponseStatus);
begin
  StatusStr := TRttiEnumerationType.GetName<TBasicResponseStatus>(Value);
end;

End.
